export const handleSubmitForm = (values, setIsSubmitting, mutateUpload) => {
  setIsSubmitting(true);

  const uploadData = {
    invImageUrl: values.invImageUrl,
    packageImageUrl: values.packageImageUrl,
    warrantyId: values.warrantyId,
    telephone: values.telephone,
    fullName: values.fullName,
    warrantyNumberCode: values.warrantyNumberCode,
    mobileBrandId: values.mobileBrandId,
    mobileModelId: values.mobileModelId,
    mapProductId: values.mapProductId,
    channelBuyId: values.channelBuyId,
    warrantyTypeId: values.warrantyTypeId,
    storeId: values.storeId,
  };
  mutateUpload(uploadData);
};
